import { LogLevel } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

// const BaEAuthConfig = {
//   auth: {
//     clientId: 'd370e4da-f5ff-46ea-812a-b6e30d0bc7a9', // This is the ONLY mandatory field that you need to supply.
//     authority: 'https://login.microsoftonline.com/76021edc-4522-4722-944f-0605dd180b9c/oauth2/v2.0/authorize',
//     // Replace the placeholder with your tenant subdomain
//     redirectUri: 'http://localhost:3000', // Points to window.location.origin. You must register this URI on Azure Portal/App1 Registration.
//     postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
//     navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
//   }
// };


export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID, // This is the ONLY mandatory field that you need to supply.
    authority: process.env.REACT_APP_ENTRA_AUTHORITY, // Replace the placeholder with your tenant subdomain
    redirectUri: process.env.REACT_APP_ENTRA_REDIRECT_URI, // Points to window.location.origin. You must register this URI on Azure Portal/App1 Registration.
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
// export const silentRequest = {
//     scopes: ["openid", "profile"],
//     loginHint: "example@domain.net"
// };